// Games.js (Updated to use SagesOfOzvaram with expanded view)
import React from 'react';
import SagesOfOzvaram from './SagesOfOzvaram';

function Games() {
    return (
        <div>
            <SagesOfOzvaram expanded={true} />
        </div>
    );
}

export default Games;